import { render } from "./OuterSelect.vue?vue&type=template&id=0fcb2405&scoped=true&ts=true"
import script from "./OuterSelect.vue?vue&type=script&lang=ts"
export * from "./OuterSelect.vue?vue&type=script&lang=ts"

import "./OuterSelect.vue?vue&type=style&index=0&id=0fcb2405&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcb2405"]])

export default __exports__